module.exports = "<div class='menubarWrapper' data-focus='accept'>\n</div>"